export default __webpack_public_path__ + "static/media/ContainerPort-Full-Color-Logo-RGB-300dpi.b9e017f7.png";